import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import type {
  SimulationServiceV1SimulationFileUploadsCreateData,
  SimulationServiceV1SimulationFileUploadsDetailData,
  SimulationServiceV1SimulationFileUploadsListData,
} from '@shipium-corp/shipium-ts-types';

export const fileUploads = {
  list: {
    queryKey: 'simulation-service/file-uploads',
    configurationType: 'cached' as const,
    fn: async (): Promise<SimulationServiceV1SimulationFileUploadsListData[]> => {
      const response = await GatewayAxiosClient.get<SimulationServiceV1SimulationFileUploadsListData[]>(
        '/simulation-proxy/api/v1/simulation/file-uploads',
      );
      return response.data;
    },
  },
  get: {
    queryKey: 'simulation-service/file-uploads/id',
    configurationType: 'cached' as const,
    fn: async (fileUploadId: string): Promise<SimulationServiceV1SimulationFileUploadsDetailData> => {
      const response = await GatewayAxiosClient.get<SimulationServiceV1SimulationFileUploadsDetailData>(
        `/simulation-proxy/api/v1/simulation/file-uploads/${fileUploadId}`,
      );
      return response.data;
    },
  },
  create: async (params: {
    s3Bucket: string;
    s3Key: string;
    originalFileName: string;
    description?: string;
    mimeType?: string;
  }) => {
    const { data } = await GatewayAxiosClient.post<SimulationServiceV1SimulationFileUploadsCreateData>(
      '/simulation-proxy/api/v1/simulation/file-uploads',
      params,
    );
    return {
      data,
      invalidateQueryKeys: [['simulation-service/file-uploads']],
    };
  },
  // Register a completed ui-reporting simulation_format export as a simulation upload.
  createFromExport: async (params: { datalakeExportId: string; originalFileName?: string }) => {
    const { data } = await GatewayAxiosClient.post<SimulationServiceV1SimulationFileUploadsCreateData>(
      '/simulation-proxy/api/v1/simulation/file-uploads/from-export',
      params,
    );
    return {
      data,
      invalidateQueryKeys: [['simulation-service/file-uploads']],
    };
  },
  delete: async (fileUploadId: string) => {
    await GatewayAxiosClient.delete(`/simulation-proxy/api/v1/simulation/file-uploads/${fileUploadId}`);
    return {
      invalidateQueryKeys: [['simulation-service/file-uploads'], ['simulation-service/file-uploads/id', fileUploadId]],
    };
  },
};
